import { render, staticRenderFns } from "./SearchResultList.vue?vue&type=template&id=56be9d30&scoped=true&"
import script from "./SearchResultList.vue?vue&type=script&lang=ts&"
export * from "./SearchResultList.vue?vue&type=script&lang=ts&"
import style0 from "./SearchResultList.vue?vue&type=style&index=0&id=56be9d30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56be9d30",
  null
  
)

export default component.exports